import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Card, CardMedia } from "@mui/material";

interface ImageButtonProps {
  width: any;
  url: string;
  onClick?: Function;
}

/**
 * Button with an image in the background
 */
export const ImageButton = ({
  width: widthProps,
  url,
  onClick,
}: ImageButtonProps) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Box sx={{ position: "relative", width: "100%", paddingTop: "160%" }}>
      <Card
        className={"shadow-box"}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          borderRadius: "10px",
          padding: "1rem 1rem 0rem 1rem",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f9f9f9",
            borderRadius: "10px",
            height: "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CardMedia
            component="img"
            image={url}
            alt={"Add shirt"}
            style={{
              height: "100%",
              borderRadius: "10px",
              objectFit: "cover",
            }}
          />
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "20%",
            margin: "0px auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Button
              startIcon={<AddIcon fontSize="small" />}
              onClick={handleOnClick}
              variant="blueGradient"
              fullWidth
              sx={{ fontSize: "14px" }}
            >
              {"Add a new shirt"}
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default ImageButton;
